"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = GroupHeading;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _styles = require("@material-ui/core/styles");
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _react = _interopRequireDefault(require("react"));
var _Typography = _interopRequireDefault(require("../../Typography"));
/* eslint react/prop-types: 0 */

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    groupHeading: {
      alignItems: 'center',
      color: 'grey',
      display: 'flex',
      height: theme.spacing(3),
      paddingLeft: theme.spacing(2)
    },
    text: {
      textTransform: 'none'
    }
  };
});
function GroupHeading(_ref) {
  var children = _ref.children,
    innerProps = _ref.innerProps,
    selectProps = _ref.selectProps;
  var customGroupHeading = {};
  if (!(0, _isEmpty["default"])(selectProps.styles)) {
    var groupHeading = selectProps.styles.groupHeading;
    customGroupHeading = groupHeading && typeof groupHeading === 'function' ? groupHeading() : {};
  }
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.groupHeading,
    "data-metrics": selectProps.dataMetrics.groupHeading,
    style: customGroupHeading
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], (0, _extends2["default"])({
    noWrap: true
  }, innerProps, {
    variant: "overline",
    className: classes.text
  }), children));
}